module.exports = __webpack_public_path__ + "img/hr-green-small-grass-03.e20fac49.png";